/* eslint-disable react/display-name */
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isFunction, get } from 'lodash';
import { animator } from 'core/modules/animation';


/**
 * @type {class}
 * @desc This view wraps navigation component of multi step manager.
 * @example
 * import { Step } from 'module/multiStepManager';
 */

export class Step extends React.Component {
    constructor( props ) {
        super( props );

        // view to render
        this.renderView = this.getRenderView( props );

        // create reder view with animation based on `props.animate`
        //this.RenderViewWithAnimation = ! isEmpty( props.animation ) ? animator( enderView, props.animation.name, props.animation.settings ) : props.view;
    }

    // Return a step view based on props
    // 1. if `render` prop function is provided, call that to render step view
    // 2. else if `props.children` is function, call that to render step view
    // 3. else use `view` prop to render step view
    getRenderView( stepComponentProps ) {
        log.debug( 'Step.getRenderView()' );
        if( ! isEmpty( stepComponentProps.view ) ) {

            return stepComponentProps.view;

        } else if( isFunction( stepComponentProps.render ) ) {

            // wrap returned JSX inside react view that accepts ref
            return React.forwardRef( ( renderProps, renderRef ) => {
                return stepComponentProps.render( renderProps, renderRef );
            } );

        } else if( isFunction( stepComponentProps.children ) ) {

            // wrap returned JSX inside react view that accepts ref
            return React.forwardRef( ( renderProps, renderRef ) => {
                return stepComponentProps.children( renderProps, renderRef );
            } );
        }
    }

    render() {
        log.debug( 'Step.render()' );

        // get context consumer
        const { context, ...restProps } = this.props;
        const { Consumer } = context;

        return (
            <Consumer>
                { ( contextValue ) => {

					const direction = contextValue.getDirection();

					const settings = {
						...get( this.props, 'animation.settings', {} ),
						direction
					};

					const RenderViewWithAnimation = ! isEmpty( this.props.animation ) ? animator( this.renderView, this.props.animation.name, settings ) : this.props.view;

                    return (
                        <RenderViewWithAnimation
                            { ...contextValue }
                            { ...restProps }
							direction = { direction }
                        />
                    );
                } }
            </Consumer>
        );
    }
}

// display name
Step.displayName = 'Step';

// prop types
Step.propTypes = {
    render: PropTypes.func,
    animation: PropTypes.object
};

// default props
Step.defaultProps = {
    animation: null
};
